// extracted by mini-css-extract-plugin
module.exports = {"select":"PrinterBluetoothInterface_select__36NqH"};